import React, { useState } from "react";
import { FaExchangeAlt, FaLock, FaMinus, FaPlus, FaChartLine, FaBalanceScale, FaCalendarCheck, FaFileInvoiceDollar, FaFileMedical, FaVideo,} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Footer from "../../../Component/Fooder";
import { motion } from 'framer-motion';
import Healthcare from "../../../assests/service/Healthcare.jpg";

const Custom = () => {
    const navigate = useNavigate();
    const [openIndex, setOpenIndex] = useState(0);

    return (
        <>
            <div className="w-full bg-gray-50">
                {/* Hero Section */}
                <div
                    className="relative w-full h-[500px] bg-cover bg-center flex flex-col items-center justify-center text-white text-center px-4 mt-2"
                    style={{ backgroundImage: `url(${Healthcare})` }}
                >
                    <div className="absolute inset-0 bg-[rgba(8,3,3,0.7)]  backdrop-blur-none"></div>
                    <motion.div
                        className="relative z-10"
                        initial={{ opacity: 0, x: -100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <h1 className="text-[30px] font-extrabold">Custom Healthcare API Solutions</h1>
                        <p className="text-lg mt-4 text-white max-w-3xl">
                            At HIKEHEALTH Gs, we specialize in designing and developing custom healthcare APIs that ensure smooth and secure communication between different healthcare systems and applications. Our solutions streamline interoperability, enabling healthcare providers to exchange critical patient data efficiently and compliantly.
                        </p>
                        <button
                            className="mt-3 px-6 py-3 bg-white text-blue-700 font-semibold rounded-lg hover:bg-gray-200 transition"
                            onClick={() => navigate("/Contact")}
                        >
                            LET’S DISCUSS YOUR NEEDS
                        </button>
                    </motion.div>
                </div>

                <div className="bg-white max-w-full mx-auto py-16 px-6">                {/* How We Can Help Section */}
                    <section className="w-full mx-auto  px-2">
                        <h2 className="text-[30px] font-bold text-center flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">How We Can Help</h2>
                        <p className="text-gray-800 text-center text-sm mt-2">
                            Exchanging healthcare data is critical, but it can be complex. We simplify the process, ensuring smooth integration.
                        </p>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto px-4 mt-4">
                            {helpFeatures.map((feature, index) => (
                                <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-4 text-center hover:scale-105 transition-transform"
                                    initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                    whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                    transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                    viewport={{ once: false, amount: 0.3 }}>
                                    <feature.icon className="text-[#2a627a] text-4xl mx-auto mb-4" />
                                    <h3 className="text-lg text-[#2a627a] font-bold">{feature.title}</h3>
                                    <p className="text-gray-800 text-sm mt-2">{feature.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </section>


                    {/* Key Interoperability Services */}
                    <section className=" py-12">
                        <div className="w-full mx-auto  ">
                            <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">Key  Services</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4 max-w-5xl mx-auto px-4">
                                {services.map((service, index) => (
                                    <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-4 text-center hover:scale-105 transition-transform"
                                        initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                        whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                        transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                        viewport={{ once: false, amount: 0.3 }}>
                                        <h3 className="text-lg font-bold text-[#2a627a]">{service.title}</h3>
                                        <p className="text-gray-800 text-sm mt-2">{service.description}</p>
                                    </motion.div>
                                ))}
                            </div>
                        </div>
                    </section>

                    {/* Why Choose Us */}
                    <section className="w-full mx-auto ">
                        <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">Why Choose Us?</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-4 max-w-5xl mx-auto px-4">
                            {whyChooseUs.map((item, index) => (
                                <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-6 text-center hover:scale-105 transition-transform"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>
                                    <h3 className="text-lg font-bold text-[#2a627a]">{item.title}</h3>
                                    <p className="text-gray-800  text-sm mt-2">{item.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </section>
                    {/* Services Section */}
                    <section className="mt-12 w-full  mx-auto">
                        {/* Heading */}
                        <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                            Discover Our Services
                        </h2>

                        {/* Service List */}
                        <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                            {List.map((service, index) => (
                                <div key={index} className="border-b border-gray-800">
                                    {/* Service Title */}
                                    <button
                                        className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                        onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                    >
                                        {service.title}
                                        {openIndex === index ? (
                                            <FaMinus className="text-red-500" />
                                        ) : (
                                            <FaPlus className="text-gray-600" />
                                        )}
                                    </button>

                                    {/* Service Description (Expandable with Animation) */}
                                    <motion.div
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                        transition={{ duration: 0.3, ease: "easeInOut" }}
                                        className="overflow-hidden"
                                    >
                                        <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                    </motion.div>
                                </div>
                            ))}
                        </div>
                    </section>



                </div>
                {/* Contact Section */}
                <div className="w-full bg-[#2a627a] text-white py-12 text-center">
                    <h2 className="text-2xl font-bold">Ready to Transform Healthcare?</h2>
                    <p className="mt-2">Let’s collaborate to build seamless and secure healthcare solutions.</p>
                    <button
                        className="mt-4 px-6 py-3 bg-gray-300 text-[#2a627a] font-semibold rounded-lg hover:bg-gray-400 transition"
                        onClick={() => navigate("/Contact")}
                    >
                        Book Your Free Consultation
                    </button>
                </div>
            </div>
            <Footer />
        </>
    );
};

// Data for different sections
const helpFeatures = [
    {
        title: "Patient Data Exchange",
        description: "Securely transfer patient records, lab results, and imaging reports across different platforms.",
        icon: FaExchangeAlt
    },
    {
        title: "EHR & EMR Integration",
        description: "Connect seamlessly with popular electronic health record (EHR) and electronic medical record (EMR) systems.",
        icon: FaFileMedical
    },
    {
        title: "Telemedicine Support",
        description: "Enable virtual consultations with integrated video conferencing and remote patient monitoring capabilities.",
        icon: FaVideo
    },
    {
        title: "Billing & Claims Processing",
        description: "Automate medical billing, insurance verification, and claims submission for faster reimbursements.",
        icon: FaFileInvoiceDollar
    },
    {
        title: "Appointment Scheduling & Notifications",
        description: "Streamline scheduling, reminders, and patient communication for better engagement.",
        icon: FaCalendarCheck
    },
    {
        title: "AI & Analytics Integration",
        description: "Leverage AI-driven insights for predictive analytics, treatment optimization, and operational efficiency.",
        icon: FaChartLine
    },
    {
        title: "Regulatory Compliance",
        description: "Ensure compliance with healthcare regulations like HIPAA and FHIR.",
        icon: FaBalanceScale
    },
    {
        title: "Data Security & Privacy",
        description: "Protect sensitive healthcare data with strong encryption and security measures.",
        icon: FaLock
    },

    // {
    //     title: "Interoperability Support",
    //     description: "Facilitate seamless data exchange between diverse healthcare systems and applications.",
    //     icon: FaNetworkWired
    // }
];


const services = [

    {
        title: "Hospitals & Clinics",
        description: "Enhancing patient care with seamless data management and interoperability solutions."
    },
    {
        title: "Telemedicine Providers",
        description: "Powering remote consultations with secure and real-time data exchange."
    },
    {
        title: "HealthTech Startups",
        description: "Supporting innovation with scalable and compliant healthcare API solutions."
    },
    {
        title: "Medical Billing Companies",
        description: "Streamlining financial workflows with automated and accurate billing integrations."
    },
    {
        title: "Insurance & Payers",
        description: "Optimizing claims processing and patient coverage verification with secure API solutions."
    },
    {
        title: "Pharmaceutical & Research Organizations",
        description: "Facilitating drug development and research with robust data analytics and interoperability."
    }
];
const whyChooseUs = [
    { title: "Seamless Integration", description: "Effortlessly integrates with EHRs, telehealth platforms, billing systems, and patient management apps." },
    { title: "FHIR & HL7 Compliance", description: "Built to industry standards like FHIR and HL7 for maximum compatibility and security." },
    { title: "Enhanced Security", description: "HIPAA-compliant encryption, role-based access control, and secure authentication to protect patient data." },
    { title: "Scalability & Performance", description: "Optimized for high-speed data processing and scalable for growing healthcare demands." },
    { title: "Customizable Solutions", description: "APIs tailored for real-time patient monitoring, appointment scheduling, and data analytics." },
    { title: "Real-Time Data Exchange", description: "Enable instant and secure data sharing for better clinical decision-making." },
    { title: "Reliable Uptime", description: "High availability and low-latency APIs to ensure uninterrupted healthcare operations." },
    { title: "Developer-Friendly", description: "Comprehensive documentation and support to accelerate implementation and reduce integration time." }
];

const List = [
    
        {
            "title": "FHIR & HL7 Compliance",
            "description": "We strictly adhere to Fast Healthcare Interoperability Resources (FHIR) and Health Level Seven (HL7) standards to ensure seamless interoperability across healthcare systems. Our compliance guarantees secure and structured data exchange, enabling smooth communication between hospitals, laboratories, and third-party applications."
        },
        {
            "title": "Enhanced Security",
            "description": "Protect patient data with industry-leading security measures, including HIPAA-compliant encryption, role-based access control (RBAC), multi-factor authentication (MFA), and audit logging. Our security-first approach ensures compliance with global healthcare regulations and minimizes the risk of data breaches."
        },
        {
            "title": "Scalability & Performance",
            "description": "Our APIs are designed for high-speed data processing, ensuring rapid information retrieval and seamless integration with large-scale healthcare systems. We leverage cloud-native architectures and microservices to provide scalable solutions that grow with increasing healthcare demands."
        },
        {
            "title": "Customizable Solutions",
            "description": "Our FHIR-based APIs can be tailored to meet your specific healthcare needs, including real-time patient monitoring, predictive analytics, remote consultations, appointment scheduling, and clinical decision support. We build flexible solutions that align with your operational workflows."
        },
        {
            "title": "Seamless EHR Integration",
            "description": "Our integration services ensure smooth connectivity with leading Electronic Health Record (EHR) systems, including Epic, Cerner, Meditech, and Allscripts. By enabling automated data sharing, we help healthcare providers streamline workflows, enhance patient care, and reduce administrative burdens."
        },
        {
            "title": "24/7 Support & Maintenance",
            "description": "Our dedicated support team offers round-the-clock monitoring, troubleshooting, and updates to ensure your healthcare APIs function optimally. We provide proactive issue resolution, regular performance enhancements, and security patches to maintain uninterrupted service."
        }
    ]
    


export default Custom;
